/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Endpoint_Reference_VerifiedInputs */

const en_endpoint_reference_verified = /** @type {(inputs: Endpoint_Reference_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last verified ${i?.day}`)
};

const zh_hans1_endpoint_reference_verified = /** @type {(inputs: Endpoint_Reference_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最近验证于 ${i?.day}`)
};

const pt_br2_endpoint_reference_verified = /** @type {(inputs: Endpoint_Reference_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Última verificação em ${i?.day}`)
};

const es_endpoint_reference_verified = /** @type {(inputs: Endpoint_Reference_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verificado por última vez el ${i?.day}`)
};

const fr_endpoint_reference_verified = /** @type {(inputs: Endpoint_Reference_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dernière vérification : ${i?.day}`)
};

const de_endpoint_reference_verified = /** @type {(inputs: Endpoint_Reference_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zuletzt geprüft ${i?.day}`)
};

const ru_endpoint_reference_verified = /** @type {(inputs: Endpoint_Reference_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Проверено ${i?.day}`)
};

const it_endpoint_reference_verified = /** @type {(inputs: Endpoint_Reference_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ultima verifica ${i?.day}`)
};

/**
* | output |
* | --- |
* | "Last verified {day}" |
*
* @param {Endpoint_Reference_VerifiedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_reference_verified = /** @type {((inputs: Endpoint_Reference_VerifiedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Reference_VerifiedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_reference_verified(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_reference_verified(inputs)
	if (locale === "es") return es_endpoint_reference_verified(inputs)
	if (locale === "fr") return fr_endpoint_reference_verified(inputs)
	if (locale === "de") return de_endpoint_reference_verified(inputs)
	if (locale === "ru") return ru_endpoint_reference_verified(inputs)
	if (locale === "it") return it_endpoint_reference_verified(inputs)
	return en_endpoint_reference_verified(inputs)
});